import { useChatbotScreen } from "../hooks/useChatbotScreen";
import { ChatbotScreenBase } from "../components/ChatbotScreenBase";

function HiCRM() {
    const props = useChatbotScreen("hi_crm");
    return <ChatbotScreenBase {...props} />;
}

export default HiCRM;
